<!-- event-form.component.html -->

<!-- Form -->
<div class="panel panel-default">
  <!-- Heading -->
  <div class="panel-heading">Enter Event Details</div>
  <!-- Body -->
  <div class="panel-body">
    <p style="color: red;">Note: * fields are mandatory.</p>
  </div>

  <!-- Categories (dynamic) -->
  <ul>
    @for (category of categories; track category.categoryId) {
      @if (category.categoryIsActive) {
        <li>
          <!-- The spacing is nicer with paragraphs -->
          <!-- <p><b>{{ category.categoryTitle }}</b>: {{ category.categoryDescription }}</p>-->
          <b>{{ category.categoryTitle }}</b>: {{ category.categoryDescription }}
        </li>
      }
    }
  </ul>

  <!-- Event -->
  <h3>Event Details:</h3>
  <br>
  <!-- Event Title -->
  <div class="form-group">
    <label class="control-label col-sm-2"><span class="mandatory">* </span>Event Title:</label>
    <div class="col-sm-10">
      <input
        formControlName="eventTitle"
        class="form-control"
        type="text"
        placeholder="Enter Event Title"
        name="title"
      >
      <!-- Validation -->
      @if (form.controls['eventTitle'].invalid && form.controls['eventTitle'].touched) {
        <small class="text-danger">Title is required</small>
      }
    </div>
  </div>
</div>

<!-- Form -->
<!--<div class="event-form">-->
<!--  <div class="panel panel-default">-->
<!--    &lt;!&ndash; Heading &ndash;&gt;-->
<!--    <div class="panel-heading">Please Enter Event Details</div>-->
<!--    &lt;!&ndash; Body &ndash;&gt;-->
<!--    <div class="panel-body">-->
<!--      <p style="color: red;">Note: * fields are mandatory.</p>-->

<!--      &lt;!&ndash; If form == create-event, show event categories w/descriptions at the top &ndash;&gt;-->
<!--      @if (isCreateMode) {-->
<!--        <ul>-->
<!--          &lt;!&ndash; Categories (dynamic) &ndash;&gt;-->
<!--          @for (category of categories; track category.categoryId) {-->
<!--            @if (category.categoryIsActive) {-->
<!--              <li><b>{{ category.categoryTitle }}</b>: {{ category.categoryDescription }}</li>-->
<!--            }-->
<!--          }-->
<!--        </ul>-->
<!--      }-->

<!--      &lt;!&ndash; Event &ndash;&gt;-->
<!--      <h3>Event Details:</h3>-->
<!--      <br>-->

<!--      &lt;!&ndash; Event Title &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label>Event Title:</label>-->
<!--        <input-->
<!--          formControlName="eventTitle"-->
<!--          class="form-control"-->
<!--          type="text"-->
<!--        >-->
<!--        <small *ngIf="form.get('eventTitle')?.invalid && form.get('eventTitle')?.touched" class="text-danger">-->
<!--          Title is required.-->
<!--        </small>-->
<!--      </div>-->

<!--      &lt;!&ndash; Event Category Dropdown (Dynamic) &ndash;&gt;-->
<!--      &lt;!&ndash; TODO: Categories are not reactive. E.g. if the backend's not running, nothing shows up. After I start the backend, nothing shows up until page refresh &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2"><span class="mandatory">* </span>Category</label>-->
<!--        <div class="col-sm-3">-->
<!--          &lt;!&ndash; Dropdown displays categoryTitle, whereas it stores categoryId inside of eventCategoryId &ndash;&gt;-->
<!--          <select-->
<!--            formControlName="eventCategoryId"-->
<!--            class="btn btn-default form-control"-->
<!--            name="category"-->
<!--          >-->
<!--            <option value="" disabled selected>&#45;&#45; Select a Category &#45;&#45;</option> &lt;!&ndash; Default option &ndash;&gt;-->
<!--            @for (category of categories; track category.categoryId) {-->
<!--              <option [value]="category.categoryId">-->
<!--                {{ category.categoryTitle }}-->
<!--              </option>-->
<!--            }-->
<!--          </select>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Event Date &ndash;&gt;-->
<!--      &lt;!&ndash; TODO:  Ensure the user cannot write a date in the past &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2">Event Date:</label>-->
<!--        <div class="col-sm-3">-->
<!--          <input-->
<!--            formControlName="eventDate"-->
<!--            class="datepicker form-control"-->
<!--            type="date"-->
<!--            [attr.min]="minDate"-->
<!--          >-->
<!--          &lt;!&ndash; Validation &ndash;&gt;-->
<!--          <small class="text-danger" *ngIf="form.controls['eventDate'].errors?.['dateInPast']">-->
<!--            Event date cannot be in the past.-->
<!--          </small>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Event Time &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2">Event Time:</label>-->
<!--        <div class="col-sm-3">-->
<!--          <input-->
<!--            formControlName="eventTime"-->
<!--            class="timepicker form-control"-->
<!--            type="time"-->
<!--            name="eventTime"-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Event Location &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2">Location:</label>-->
<!--        <div class="col-sm-10">-->
<!--          <input-->
<!--            type="text"-->
<!--            class="form-control"-->
<!--            placeholder="Enter Event Location"-->
<!--            name="event_location"-->
<!--            formControlName="eventLocation"-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Event Description (WYSIWYG) &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2"><span class="mandatory">* </span> Description:</label>-->
<!--        <div class="col-sm-10">-->
<!--          <app-quill-editor formControlName="eventDescription"></app-quill-editor>-->
<!--          &lt;!&ndash; Validation &ndash;&gt;-->
<!--          @if (form.controls['eventDescription'].invalid && form.controls['eventDescription'].touched) {-->
<!--            <small class="text-danger">Description is required</small>-->
<!--          }-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Event Url &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <p class="mandatory col-lg-offset-2" style="margin-left: 19%;">Note: Please enter complete URL.</p>-->
<!--        <label class="control-label col-sm-2">Link to Website:</label>-->
<!--        <div class="col-sm-10">-->
<!--          <input-->
<!--            formControlName="eventUrl"-->
<!--            class="form-control"-->
<!--            type="text"-->
<!--            placeholder="https://www.fairfield.edu/"-->
<!--            name="link"-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Announcement Start Date (datepicker) &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2"><span class="mandatory">* </span>Posting Start Date:</label>-->
<!--        <div class="col-sm-3">-->
<!--          <input-->
<!--            formControlName="announcementStartDate"-->
<!--            class="datepicker form-control"-->
<!--            type="date"-->
<!--            [attr.min]="minDate"-->
<!--          >-->
<!--          &lt;!&ndash; Validation &ndash;&gt;-->
<!--          <small class="text-danger"-->
<!--                 *ngIf="form.controls['announcementStartDate'].hasError('required') && form.controls['announcementStartDate'].touched">-->
<!--            Posting start date is required.-->
<!--          </small>-->
<!--          &lt;!&ndash;              *ngIf="!form.controls['announcementStartDate'].hasError('required') && form.controls['announcementStartDate'].hasError('dateInPast')">&ndash;&gt;-->
<!--          <small class="text-danger"-->
<!--                 *ngIf="form.controls['announcementStartDate'].hasError('dateInPast')">-->
<!--            Announcement start date cannot be in the past.-->
<!--          </small>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Announcement End Date (datepicker) TODO &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2"><span class="mandatory">* </span>Posting End Date:</label>-->
<!--        <div class="col-sm-3">-->
<!--          <input-->
<!--            formControlName="announcementEndDate"-->
<!--            class="datepicker form-control"-->
<!--            type="date"-->
<!--            name="endDt"-->
<!--            [attr.min]="minDate"-->
<!--          >-->
<!--          &lt;!&ndash; Validation &ndash;&gt;-->
<!--          <small class="text-danger"-->
<!--                 *ngIf="form.controls['announcementEndDate'].hasError('required') && form.controls['announcementEndDate'].touched">-->
<!--            Posting start date is required.-->
<!--          </small>-->
<!--          &lt;!&ndash;              *ngIf="!form.controls['announcementEndDate'].hasError('required') && form.controls['announcementEndDate'].hasError('dateInPast')">&ndash;&gt;-->
<!--          &lt;!&ndash;              *ngIf="!form.controls['announcementEndDate'].hasError('required') && form.controls['announcementEndDate'].errors?.['dateInPast']">&ndash;&gt;-->
<!--          <small class="text-danger"-->
<!--                 *ngIf="form.controls['announcementEndDate'].errors?.['dateInPast']">-->
<!--            Announcement start date cannot be in the past.-->
<!--          </small>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Contact &ndash;&gt;-->
<!--      <hr>-->
<!--      <h3>Contact Details:</h3>-->
<!--      <br>-->
<!--      &lt;!&ndash; Contact Name &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2"><span class="mandatory">* </span>Contact Name:</label>-->
<!--        <div class="col-sm-3">-->
<!--          <input-->
<!--            formControlName="contactName"-->
<!--            class="form-control"-->
<!--            type="text"-->
<!--            name="con_name"-->
<!--          >-->
<!--          &lt;!&ndash; Validation &ndash;&gt;-->
<!--          @if (form.controls['contactName'].invalid && form.controls['contactName'].touched) {-->
<!--            <small class="text-danger">Contact name is required</small>-->
<!--          }-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Contact Phone TODO: phone format &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2"><span class="mandatory">* </span>Phone:</label>-->
<!--        <div class="col-sm-3">-->
<!--          <input-->
<!--            formControlName="contactPhone"-->
<!--            class="form-control"-->
<!--            type="text"-->
<!--            name="con_phone"-->
<!--          >-->
<!--          &lt;!&ndash; Validation &ndash;&gt;-->
<!--          @if (form.controls['contactPhone'].invalid && form.controls['contactPhone'].touched) {-->
<!--            <small class="text-danger">Phone is required</small>-->
<!--          }-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Contact Email &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2"><span class="mandatory">* </span>Email:</label>-->
<!--        <div class="col-sm-3">-->
<!--          <input-->
<!--            formControlName="contactEmail"-->
<!--            class="form-control"-->
<!--            type="email"-->
<!--            name="con_email"-->
<!--          >-->
<!--          &lt;!&ndash; Validation &ndash;&gt;-->
<!--          @if (form.controls['contactEmail'].invalid && form.controls['contactEmail'].touched) {-->
<!--            <small class="text-danger">Email is required</small>-->
<!--          }-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Announcement Submitted By &ndash;&gt;-->
<!--      <div class="form-group">-->
<!--        <label class="control-label col-sm-2"><span class="mandatory">* </span>Submitted By:</label>-->
<!--        <div class="col-sm-3">-->
<!--          <input-->
<!--            formControlName="announcementSubmittedBy"-->
<!--            class="form-control"-->
<!--            type="text"-->
<!--            name="submitted_by"-->
<!--          >-->
<!--          &lt;!&ndash; Validation &ndash;&gt;-->
<!--          @if (form.controls['announcementSubmittedBy'].invalid && form.controls['announcementSubmittedBy'].touched) {-->
<!--            <small class="text-danger">Submitted by is required</small>-->
<!--          }-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
